import { PreprocessorCompanyContacts } from './preprocessor-company-contacts.interface';
import { PreprocessorCompanyContactsGeneral } from './preprocessor-company-contacts-general';
import { PreprocessorCompanyContactsProperty } from './preprocessor-company-contacts-property';
import { DataObject } from '../../models/report.model';
import { EntityType } from '../constants/entity.const';

export function processCompanyContacts(entityType: string, record: DataObject): DataObject {
  let preprocessor: PreprocessorCompanyContacts;
  if (entityType === 'property_building' || entityType === EntityType.Property) {
    preprocessor = new PreprocessorCompanyContactsProperty();
  } else {
    preprocessor = new PreprocessorCompanyContactsGeneral();
  }
  return preprocessor.processCompanyContacts(record);
}
